/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popDeposit.vue?vue&type=template&id=37ac934a&scoped=true"
import script from "./popDeposit.vue?vue&type=script&lang=js"
export * from "./popDeposit.vue?vue&type=script&lang=js"
import style0 from "./popDeposit.vue?vue&type=style&index=0&id=37ac934a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ac934a",
  null
  
)

export default component.exports